import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { FloatingWhatsApp } from './FloatingWhatsApp';
export function Layout() {
  return <div className="min-h-screen bg-white selection:bg-brand-green/20 selection:text-brand-navy flex flex-col" data-id="element-296">
      <Header data-id="element-297" />
      <main className="flex-1" data-id="element-298">
        <Outlet data-id="element-299" />
      </main>
      <Footer data-id="element-300" />
      <FloatingWhatsApp data-id="element-301" />
    </div>;
}